import React from 'react';

interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  activeTab: string;
  setActiveTab: (tabId: string) => void;
  tabs: Tab[];
}

const Tabs: React.FC<TabsProps> = ({ activeTab, setActiveTab, tabs }) => {
  console.log('Tabs rendering, activeTab:', activeTab);

  return (
    <div className="border-b">
      <nav className="flex space-x-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`py-3 px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.id
                ? 'border-talaera-blue text-talaera-blue'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200'
            } transition-colors`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Tabs; 